export default __webpack_public_path__ + "static/media/captur-gallery-3.288727ce.jpg";